import { BoardOperations } from "../../components/Operations";

export const Operations = () => {
  return <BoardOperations />;
};
